module.exports = __webpack_public_path__ + "static/media/arrow-up-light.1c498481.svg";